import { tagMap } from '@/utils/constants'

import CommandersPage, { getServerSideProps as defaultGetServersideProps } from '..'

export const getServerSideProps = async (context: any) => {
  const tag = context.query.tag as string

  if (tagMap[tag as keyof typeof tagMap]) {
    return {
      redirect: {
        destination: `/commanders/${context.query.slug}/${tagMap[tag as keyof typeof tagMap]}`,
        permanent: false,
      },
    }
  }

  return defaultGetServersideProps(context)
}

export default CommandersPage
